module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 32);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 16:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Spacing;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var spacingTypes = ['margin', 'padding'];
var spacingSizes = ['0', 'xxs', 'xs', 's', 'm', 'l', 'xl'];
var spacingPositions = {
  top: 'Top',
  right: 'Right',
  bottom: 'Bottom',
  left: 'Left',
  topBottom: 'TopBottom',
  leftRight: 'LeftRight',
  none: ''
};

function Spacing(_ref) {
  var _cx;

  var children = _ref.children,
      type = _ref.type,
      position = _ref.position,
      size = _ref.size,
      sizeS = _ref.sizeS,
      sizeM = _ref.sizeM,
      sizeL = _ref.sizeL;

  var spacingPosition = position ? spacingPositions[position] : '';
  var spacingClass = (0, _classnames2.default)('' + type + spacingPosition + '-' + size, (_cx = {}, _defineProperty(_cx, 'breakPointS-' + type + spacingPosition + '-' + sizeS, sizeS), _defineProperty(_cx, 'breakPointM-' + type + spacingPosition + '-' + sizeM, sizeM), _defineProperty(_cx, 'breakPointL-' + type + spacingPosition + '-' + sizeL, sizeL), _cx));

  return _react2.default.createElement(
    'div',
    { className: spacingClass },
    children
  );
}

Spacing.propTypes = {
  children: _propTypes2.default.node.isRequired,
  position: _propTypes2.default.oneOf(Object.keys(spacingPositions)),
  size: _propTypes2.default.oneOf(spacingSizes),
  sizeL: _propTypes2.default.oneOf(spacingSizes),
  sizeM: _propTypes2.default.oneOf(spacingSizes),
  sizeS: _propTypes2.default.oneOf(spacingSizes),
  type: _propTypes2.default.oneOf(spacingTypes)
};

Spacing.defaultProps = {
  position: 'none',
  type: 'margin'
};

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("classnames");

/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Spacing = __webpack_require__(16);

var _Spacing2 = _interopRequireDefault(_Spacing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Spacing2.default;

/***/ })

/******/ });
//# sourceMappingURL=marvel-ui-spacing.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@marvelapp/marvel-ui/lib/marvel-ui-spacing.js
// module id = 1115
// module chunks = 168707334958949